import { AppData, Log } from "@lightningjs/sdk";
import Lightning from "@lightningjs/sdk/src/Lightning"
import { ScrollWrapper } from "@lightningjs/ui-components";
import { AppSetup } from "../../lib/app-setup";

export interface PolicyTabTemplateSpec extends Lightning.Component.TemplateSpecLoose {
  page: any
}

export default class PolicyTab
  extends Lightning.Component<PolicyTabTemplateSpec>
  implements Lightning.Component<PolicyTabTemplateSpec>
{
  static override _template(): Lightning.Component.Template<PolicyTabTemplateSpec> {
    return {
      w: (w) => w,
      h: (h) => h,
      clipping: true,
      collision: true,
      Background: {
        w: 1920,
        h: 1080,
      },
      ScrollWrapper: undefined,
      Logo: {
        x: 122,
        y: 80,
      },
      Title: {
        x: 122,
        y: 160,
        text: {
          text: '',
          fontSize: 43,
          fontStyle: 'bold',
        }
      },
      Description: {
        x: 122,
        y: 230,
        w: 800,
        text: {
          text: '',
          fontSize: 26,
          lineHeight: 38,
          wordWrap: true
        }
      },
      QrCode: {
        x: 122,
        y: 340,
        w: 260,
        h: 260,
        src: null
      }
    }
  }

  override _focus() {
    this.tag('ScrollWrapper').showScrollBar = true;
  }

  override _unfocus() {
    this.tag('ScrollWrapper').showScrollBar = false;
  }

  override _getFocused() {
    return this.tag('ScrollWrapper');
  }

  _getContentByLine(longText: string) {
    // const lineList:string[] = longText.split('\n')
    const lineList = longText
      .replace(/\r/g, "")
      .split("\n")
      .map(line => line.trim())
      .filter(line => line !== "");

    const textObj = lineList.map(line => {
      return {
        text: line,
      }
    })
    return textObj
  }

  set headerData(header: { title: string, description: string, qrCodeIcon: string }) {
    this.patch({
      Title: {
        text: header.title
      },

      Description: {
        text: header.description
      },
      QrCode: {
        src: header.qrCodeIcon
      }
    })
  }

  _handleScroll(obj) {
        // console.log('ScrollText _handleScroll: ',  obj)
        if(obj && obj.wheelDeltaY && obj.wheelDeltaY>0) {
            //this.onUp()
        } else {
            //this.onDown()
        }
    }

  set data(text: string) {
    Log.info('PolicyTab: data:', text, this._getContentByLine(text))

    const contentStyle = this._getContentByLine(text).map(item => ({
      text: item.text,
      style: {
        fontFamily: 'SFPro-Light',
        lineHeight: 50,
        textColor: 0xffffffff,
        fontSize: 28,
      }
    }));
    this.patch({
      ScrollWrapper: {
        x: 90,
        y: 620,
        type: ScrollWrapper,
        w: 1800,
        h: 450,
        scrollStep: 100,
        scrollDuration: 0.5,
        content: contentStyle
      }
    })
  }

  _getLogo() {
    const { appState } = AppData as AppSetup
    const app = appState?.getApp()
    this.patch({
      Logo: {
        texture: {
          src: app?.appApiConfig?.appBrandConfig?.header_logo,
          resizeMode: {
            h: 60,
            w: 460,
            type: 'contain',
          },
          type: Lightning.textures.ImageTexture
        },
      }
    })
  }

  override _init() {
    this._getLogo();
    const { appState } = AppData as AppSetup;
    const appApiConfig = appState?.getAppApiConfig();
    if (appApiConfig?.appBrandConfig?.iptv_background) {
      this.patch({
        Background: {
          src: appApiConfig.appBrandConfig.iptv_background,
        },
      });
    }
  }

}
